import { Column, Id } from "@dgs/core";
import { FC } from "react";
import styled from "styled-components";
import { FeedbackQuestionEvaluationResource } from "../types/feedback";
import { CompactFeedbackChoiceQuestionEvaluation } from "./CompactFeedbackChoiceQuestionEvaluation";
import { CompactFeedbackFreeTextQuestionEvaluation } from "./CompactFeedbackFreeTextQuestionEvaluation";
import { CompactFeedbackNumberQuestionEvaluation } from "./CompactFeedbackNumberQuestionEvaluation";
import { CompactFeedbackNumberRatingQuestionEvaluation } from "./CompactFeedbackNumberRatingQuestionEvaluation";
import { CompactFeedbackRatingQuestionEvaluation } from "./CompactFeedbackRatingQuestionEvaluation";

const Bold = styled.span`
	font-weight: ${({ theme }) => theme.fonts.weights.bold};
`;

interface Props {
	eventId: Id;
	question: FeedbackQuestionEvaluationResource;
}
export const CompactFeedbackQuestionEvaluation: FC<Props> = ({ eventId, question }) => {
	return (
		<Column $rowGap={1}>
			<Bold>{question.text}</Bold>
			<CompactFeedbackQuestionEvaluationRow eventId={eventId} question={question} />
		</Column>
	);
};

const CompactFeedbackQuestionEvaluationRow: FC<Props> = ({ eventId, question }) => {
	switch (question.type) {
		case "freeText":
			return <CompactFeedbackFreeTextQuestionEvaluation eventId={eventId} question={question} />;
		case "rating":
			return <CompactFeedbackRatingQuestionEvaluation question={question} />;
		case "numberRating":
			return <CompactFeedbackNumberRatingQuestionEvaluation question={question} />;
		case "singleChoice":
		case "multipleChoice":
			return <CompactFeedbackChoiceQuestionEvaluation question={question} />;
		case "number":
			return <CompactFeedbackNumberQuestionEvaluation question={question} />;
	}
};
